import { Navigate, useLocation } from 'react-router-dom';

export const BRANCH2_AUTH_KEY = 'isBranch2Staff8Am';
export const BRANCH2_LOGIN_TIME_KEY = 'branch2LoginTime8Am';
const TIMEOUT_DURATION = 8 * 60 * 60 * 1000; // 8 giờ (nhân viên làm cả ca)

/**
 * ProtectedRoute dành riêng cho nhân viên cơ sở 2.
 * Kiểm tra localStorage key riêng độc lập với admin session.
 */
const Branch2ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const isAuth = localStorage.getItem(BRANCH2_AUTH_KEY) === 'true';
  const loginTime = Number(localStorage.getItem(BRANCH2_LOGIN_TIME_KEY) || 0);

  if (isAuth && Date.now() - loginTime > TIMEOUT_DURATION) {
    localStorage.removeItem(BRANCH2_AUTH_KEY);
    localStorage.removeItem(BRANCH2_LOGIN_TIME_KEY);
    return <Navigate to="/branch2-login" state={{ from: location }} replace />;
  }

  if (!isAuth) {
    return <Navigate to="/branch2-login" state={{ from: location }} replace />;
  }

  // Refresh session on activity
  localStorage.setItem(BRANCH2_LOGIN_TIME_KEY, Date.now().toString());
  return children;
};

export default Branch2ProtectedRoute;
